<template>
  <div class="component-filter-daterange">
    <div class="inner-wrap">
      <div class="content">
         <el-date-picker
            v-model="option.data"
            @input="changeOptionEvent"
            type="daterange"
            :range-separator="$t('filter.to')"
            :start-placeholder="$t('filter.start_date')"
            :end-placeholder="$t('filter.end_date')"
            :clearable="false">
          </el-date-picker>
      </div>
      <div class="footer">
        <vxe-button @click="resetEvent" size="mini">{{ $t("button.clear") }}</vxe-button>
        <vxe-button status="primary" @click="confirmEvent" size="mini" :disabled="typeof option.data == 'undefined' || option.data.length == 0">{{ $t("button.confirm") }}</vxe-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterDaterange',
  props: {
    params: Object,
    renderOpts: Object
  },
  data () {
    return {
      column: null,
      option: null
    }
  },
  created () {
    this.load()
    if(this.renderOpts.selectedOptions) {
      this.option.data = [
        new Date(this.renderOpts.selectedOptions[0]*1000),
        new Date(this.renderOpts.selectedOptions[1]*1000-1)
      ];
    }
    if(this.column) {
      this.changeOptionEvent();
    }
  },
  methods: {
    load () {
      const { column } = this.params
      const option = column.filters[0]
      this.column = column
      this.option = option
    },
    changeOptionEvent () {
      const { params, option } = this
      const { $panel } = params
      const checked = !!option.data
      $panel.changeOption(null, checked, option)
    },
    keyupEvent ({ $event }) {
      const { params } = this
      const { $panel } = params
      if ($event.keyCode === 13) {
        $panel.confirmFilter()
      }
    },
    confirmEvent () {
      const { $panel } = this.params
      $panel.confirmFilter()
    },
    resetEvent () {
      const { $panel } = this.params
      $panel.resetFilter()
    }
  }
}
</script>

<style lang="scss">
.component-filter-daterange {
  padding: 10px;
  .footer{
    margin-top: 5px;
  }
}
</style>